import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import Toggle from '../Toggle'
import MaterialSelector from '../MaterialSelector'
import ImageScrubber from '../ImageScrubber'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView07ImageOptions } from './views/ExteriorView07'
import { exteriorView05ImageOptions } from './views/ExteriorView05'

const OUTBOARD_BRACKET_VIEW_BINDINGS = [
  { index: 1, option: 'OutboardBracket', values: [2] }
]

class X46MK2Cockpit extends Component {
  constructor (props) {
    super(props)
    this.handleBenchExtensionsChange =
      this.handleBenchExtensionsChange.bind(this)
    this.handleCushionBackrestsChange =
      this.handleCushionBackrestsChange.bind(this)
    this.handleCushionSeatsChange = this.handleCushionSeatsChange.bind(this)
    this.handleCockpitFabricChange = this.handleCockpitFabricChange.bind(this)
    this.handleOutboardBracketChange =
      this.handleOutboardBracketChange.bind(this)
    this.handleGTSeatChange = this.handleGTSeatChange.bind(this)
  }

  updateConfiguration (changes) {
    if (this.props.onChange) {
      this.props.onChange({
        ...this.props.configuration,
        ...changes
      })
    }
  }

  handleBenchExtensionsChange (event) {
    this.updateConfiguration({
      CockpitBenchExtentions: event.target.checked
        ? this.props.cockpitBenchExtentionsOptions[1]
        : this.props.cockpitBenchExtentionsOptions[0]
    })
  }

  handleCushionBackrestsChange (event) {
    this.updateConfiguration({
      CockpitCushionBackrests: event.target.checked
        ? this.props.cockpitCushionBackrestsOptions[1]
        : this.props.cockpitCushionBackrestsOptions[0]
    })
  }

  handleCushionSeatsChange (event) {
    this.updateConfiguration({
      CockpitCushionSeats: event.target.checked
        ? this.props.cockpitCushionSeatsOptions[1]
        : this.props.cockpitCushionSeatsOptions[0]
    })
  }

  handleCockpitFabricChange (newValue) {
    this.updateConfiguration({ CockpitFabric: newValue })
  }

  handleOutboardBracketChange (event) {
    this.updateConfiguration({
      OutboardBracket: event.target.checked
        ? this.props.outboardBracketOptions[1]
        : this.props.outboardBracketOptions[0]
    })
  }

  handleGTSeatChange (event) {
    this.updateConfiguration({
      GTSeat: event.target.checked
        ? this.props.gtSeatOptions[1]
        : this.props.gtSeatOptions[0]
    })
  }

  render () {
    const configuration = this.props.configuration
    const showCockpitFabric =
      configuration.CockpitCushionBackrests.value === 2 ||
      configuration.CockpitCushionSeats.value === 2

    const image = (
      <ImageScrubber
        configuration={configuration}
        viewBindings={OUTBOARD_BRACKET_VIEW_BINDINGS}
        images={[
          <X46MK2ConfiguratorImageWithOverlays
            key='exteriorView07'
            boat='X46MK2'
            configuration={configuration}
            options={exteriorView07ImageOptions}
          />,
          <X46MK2ConfiguratorImageWithOverlays
            key='exteriorView05'
            boat='X46MK2'
            configuration={configuration}
            options={exteriorView05ImageOptions}
          />
        ]}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Cockpit' />
          </h1>

          <p className='RadioGroup-title'>
            <Trans defaults='Options:' />
          </p>

          <Toggle
            checked={configuration.CockpitBenchExtentions.value >= 2}
            onChange={this.handleBenchExtensionsChange}
          >
            <Trans defaults='Cockpit bench extensions' />
          </Toggle>

          <Toggle
            checked={configuration.CockpitCushionBackrests.value === 2}
            onChange={this.handleCushionBackrestsChange}
          >
            <Trans defaults='Cockpit cushion backrests' />
          </Toggle>

          <Toggle
            checked={configuration.CockpitCushionSeats.value === 2}
            onChange={this.handleCushionSeatsChange}
          >
            <Trans defaults='Cockpit cushion seats' />
          </Toggle>

          {showCockpitFabric && (
            <React.Fragment>
              <h2>
                <Trans defaults='Cockpit fabric' />
              </h2>
              <MaterialSelector
                label={configuration.CockpitFabric.label}
                options={this.props.cockpitFabricOptions}
                value={configuration.CockpitFabric}
                onChange={this.handleCockpitFabricChange}
              />
            </React.Fragment>
          )}

          <Toggle
            checked={configuration.OutboardBracket.value === 2}
            onChange={this.handleOutboardBracketChange}
          >
            <Trans defaults='Outboard bracket' />
          </Toggle>

          <Toggle
            checked={configuration.GTSeat.value === 2}
            onChange={this.handleGTSeatChange}
          >
            <Trans defaults='Foldable pushpit seats' />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Cockpit)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Cockpit.js